module.exports = __webpack_public_path__ + "img/refresh.1a75858c.svg";